import { Injectable } from '@angular/core';
import { ApiRequestService } from './api-request.service';
import { merge } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploaderService {
  private readonly resourceUrl = 'v1/file-uploader';

  constructor(private api: ApiRequestService) {}

  public storeUploadedFiles(
    files: FileList,
    parentType: string,
    parentId: number
  ) {
    const requests = [];
    for (let i = 0; i < files.length; i++) {
      const form = new FormData();
      form.set('file', files[i], files[i].name);
      requests.push(
        this.api.makeRequestObservable(
          'post',
          this.resourceUrl + `/${parentType}/${parentId}`,
          form
        )
      );
    }
    return merge(...requests);
  }
}
